import { createTheme, ThemeProvider, CssBaseline, GlobalStyles } from '@mui/material';
import React from 'react';
import Box from '@mui/material/Box';
import Main from './Main';
import About from './About';
import Experience from './Experience';
import Project from './Projects';
import Skills from './Skills';
import Certifications from './Certifications';
import Quote from './Quote';

const darktheme = createTheme({
    palette: {
        mode: "dark",
        background: {
            default: "#000000", // Set the default background color to black
        },
    },
});

const Home = () => {
    return (
        <ThemeProvider theme={darktheme}>
            <CssBaseline />
            <GlobalStyles styles={{ body: { margin: 0, padding: 0 } }} />

            {/* Fixed background layer */}
            <Box
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: -1, // Ensure it's behind other elements
                    backgroundColor: 'black',
                    background: 'radial-gradient(ellipse 80% 80% at 50% -20%, rgba(120,119,198,0.3), rgba(255,255,255,0))',
                    

                }}
            />

            {/* Scrollable content */}
            <Box
                sx={{
                    minHeight: '100vh',
                    color: 'white',
                    overflow: 'auto', // Enables scrolling of content
                    position: 'relative',
                }}
            >
                <Box>
                    <Main />
                    
                    <About />
                    
                    <Experience />
                    
                    <Project />

                    <Skills />

                    <Certifications />

                    <Quote />
                </Box>
            </Box>
        </ThemeProvider>
    );
};

export default Home;
